(() => {
  'use strict';

  // The mobile nav is a plain <details>, which is what makes it work without scripting and
  // keyboard-operable for free. What <details> does not give you is the behaviour every
  // touch user expects of an open overlay: tapping outside it, or pressing Escape, should
  // close it. Without that the only way out was to find the burger again — and on a phone
  // the natural gesture is to tap the dimmed area.
  //
  // Everything here is additive. With JS off the menu still opens and closes from the
  // summary exactly as before.

  const nav = document.querySelector('[data-mobile-nav]');
  if (!nav) return;

  const close = () => nav.removeAttribute('open');

  // The overlay is opaque and full-screen, so "outside" is only ever the header bar itself
  // — the logo and the cart link, which sit above it. Tapping either should leave the menu
  // rather than act with a menu still open behind the new page.
  document.addEventListener('pointerdown', (event) => {
    if (!nav.hasAttribute('open')) return;
    if (nav.contains(event.target)) return;
    close();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !nav.hasAttribute('open')) return;
    close();
    nav.querySelector('summary')?.focus();
  });

  // Navigating within the same document (an in-page anchor, or a Shopify view transition)
  // leaves the panel hanging open over the new content otherwise.
  window.addEventListener('pageshow', close);
})();
